import { render, staticRenderFns } from "./niveldeacesso.vue?vue&type=template&id=1fb4d355&"
import script from "./niveldeacesso.vue?vue&type=script&lang=js&"
export * from "./niveldeacesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports